import ConversationsOptionState from './schema/ConversationsOptionState';
import { createStore } from 'satcheljs';

export default createStore<ConversationsOptionState>('conversationsOption', {
    conversationSortOrder: null,
    hideDeletedItems: null,
    globalListViewType: null,
})();
